import { B2bComponent } from '../b2b.component';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { B2BService } from 'src/app/b2-b.service';

@Component({
  selector: 'app-offer-request-confirmation',
  templateUrl: './offer-request-confirmation.component.html',
  styleUrls: ['./offer-request-confirmation.component.css']
})
export class OfferRequestConfirmationComponent implements OnInit {

  constructor(public parent: B2bComponent, private managementService:ManagementServiceService, private B2BService:B2BService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) { 
    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }
 
  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  searchTermUpdate = new Subject<string>();
  RequestOfferID:string;
  OfferRequest: {[k: string]: any} = {};

  ngOnInit(): void {
    this.parent.loading = true;
    this.getParamValues();
  }

  getParamValues() {
    this.route.queryParams.subscribe(params => {
      // Scroll to top on every navigation (not just initial load)
      // Target the scrollable container first, then fallback to window
      const scrollContainer = document.querySelector('.loginBodyContainer');
      if (scrollContainer) {
        scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      if(params['RequestOfferID']){
        this.RequestOfferID = params['RequestOfferID'];
        this.GetOffer(this.RequestOfferID);
      }
    });
  }

  ConfirmationMessage:string;

  GetOffer(RequestOfferID:string){
      var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      RequestOfferID:RequestOfferID,
      GetCartItems:true,
      WithLogs:true,
    };

    this.B2BService.GetOffer(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.OfferRequest = response["OfferRequest"];
        this.ConfirmationMessage = response["ConfirmationMessage"];
      }

      this.parent.loading = false;
    });

  }

  ShowAllProductsDetails:boolean = false;

  ShowAllProductsDetailsFunction(e:boolean){
    this.ShowAllProductsDetails = e;
    this.OfferRequest.Cart.Items.forEach(element => {
      element.Product.ShowDetails = e;
    });
  }

}
